<template>
  <div class="vertical-nav nav-collapsed flex">
    <div class="sidebar-mask"></div>

    <div class="sidebar box pos-left">
      <div class="scroll-nav" v-bar="{ useScrollbarPseudo: true }">
        <div>
          <el-menu class="nav-collapsed" :collapse="true" :router="false">
            <el-menu-item class="company-logo" :index="'logo'">
              <el-tooltip class="item" effect="dark" content="Dashboard" placement="right" :enterable="false">
                <logo @push-page="pushPage" :disabled="disabled" />
              </el-tooltip>
            </el-menu-item>
            <el-menu-item :index="'close_nav'" @click="collapseNavToggle" :disabled="disabled">
              <el-tooltip class="item" effect="dark" content="Expand/Collapse" placement="right" :enterable="false">
                <i class="mdi material-icons" :class="{ 'icon-menu': collapseNav }">menu</i>
              </el-tooltip>
            </el-menu-item>
            <el-menu-item :index="'notification'" @click="notificationToggle">
              <el-tooltip class="item" effect="dark" content="Notifications" placement="right" :enterable="false">
                <el-badge v-if="isUnread" is-dot class="item">
                  <i class="mdi material-icons">notification_important</i>
                </el-badge>
                <i v-else class="mdi material-icons">notification_important</i>
              </el-tooltip>
            </el-menu-item>
            <el-submenu :index="'documentation'" popper-class="main-navigation-submenu" :disabled="disabled">
              <template slot="title">
                <i class="mdi material-icons">help_outline</i>
              </template>
              <el-menu-item :index="'user_guide'" @click="loadDocumentation('page-home')">
                <span class="body1"><span class="format-text">User Guide</span></span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="Integrations-Launchpad" @click="goToLaunchpad">
              <el-tooltip
                class="item"
                effect="dark"
                content="Integrations-Launchpad"
                placement="right"
                :enterable="false"
              >
                <img style="height:19px; width:19px;" src="/static/images/rocket.svg" alt="ICON" />
              </el-tooltip>
            </el-menu-item>
            <el-menu-item index="logout" @click="logout">
              <el-tooltip class="item" effect="dark" content="logout" placement="right" :enterable="false">
                <div class="avatar-container-logout">
                  <div class="avatar-text-logout">
                    <span style="visibility: visible;overflow: visible;padding: 2px 0 0 8px;"
                      >{{ userProfile.firstname[0] }}{{ userProfile.lastname[0] }}</span
                    >
                  </div>
                </div>
              </el-tooltip>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-aside width="180" class="box" :class="{ 'nav-collapsed': collapseNav }">
      <the-nav ref="mainNav" :is-collapse="collapseNav" @push-page="pushPage" />
    </el-aside>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheNav from '@/components/layout/TheNav.vue'
import Logo from '@/components/layout/Logo.vue'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

import { USER_PROFILE_IMG_GET } from '@/store/modules/user/user.type'

export default {
  name: 'TheVerticalNav',
  props: ['collapseNav', 'navView', 'disabled', 'isUnread'],
  mixins: [loadDocumentationMixin],
  data () {
    return {
      isProfileImgSet: false
    }
  },
  methods: {
    collapseNavToggle () {
      this.$emit('collapse-nav-toggle')
    },
    notificationToggle () {
      this.$emit('notification-toggle')
    },
    pushPage (indexPath) {
      this.$emit('update:navView', indexPath.sideNav ? indexPath.sideNav.title : '')
    },
    closeNav () {
      this.collapseNav = false
    },
    goToLaunchpad () {
      this.$router.push({ name: 'integrations' })
    },
    goToAccount () {
      this.$router.push({ name: 'account', query: { view: 'profile' } })
    },
    logout () {
      this.$router.push({ name: 'logout' })
    }
  },
  beforeMount () {
    if (this.isAuthenticated && !_.isEmpty(this.userProfile) && !this.userProfileImg) {
      this.$store
        .dispatch(USER_PROFILE_IMG_GET, {
          userId: this.userProfile.id
        })
        .then(
          data => {
            if (data['profileImg']) {
              this.isProfileImgSet = true
              this.imgDataUrl = data['profileImg']
            }
          },
          errMsg => {
            console.log(errMsg)
          }
        )
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'userProfile', 'userProfileImg', 'iqportalVersion', 'iqhubVersion'])
  },
  components: {
    TheNav,
    Logo
  }
}
</script>

<style>
@import 'assets/styles/global_classes.css';
@import 'assets/styles/_variables.css';

.vertical-nav {
  display: flex;
  height: 100%;
  padding: 0px 0px;
  box-sizing: border-box;
  transition: width 0.5s cubic-bezier(0.2, 0, 0, 1) 0s;

  .avatar-profile {
    border-radius: 50%;
  }

  .sidebar-mask {
    visibility: hidden;
    opacity: 0;
    transition: all 0.5s;
  }

  .scroll-nav,
  .el-menu,
  .el-aside {
    height: 100%;
    background: var(--the-menu-bg-color);
  }

  .sidebar,
  .el-aside {
    padding-top: 32px;
    background: var(--the-menu-bg-color);
  }

  .el-divider {
    height: 100%;
    margin: 0px;
    color: var(--aluminum-700);
    background-color: var(--aluminum-700);
  }

  .sidebar {
    height: 100%;
    transition: width 0.5s cubic-bezier(0.2, 0, 0, 1) 0s;

    .box-nav {
      overflow: hidden;
      padding-top: 15px;

      .scroll-nav {
        height: 100%;
      }
    }

    &:not(.pos-right) {
      .box-nav {
        .scroll-nav {
          &.vb {
            & > .vb-content {
              margin-left: 4px;
            }
            & > .vb-dragger {
              /* left: 3px; */
              right: inherit;
            }
          }
          .ps__scrollbar-y-rail {
            left: 0px;
            right: inherit;
          }
        }
      }
    }
  }

  &.nav-collapsed {
    .sidebar {
      width: 64px;
      min-width: 64px;
    }
  }

  .el-aside {
    will-change: width;
    transition: width 0.5s cubic-bezier(0.2, 0, 0, 1) 0s;

    &.nav-collapsed {
      transition: width 0.5s cubic-bezier(0.2, 0, 0, 1) 0s;
      width: 0px !important;
    }
  }

  .el-menu-item.company-logo {
    height: 44px;
    padding-left: 15.5px !important;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    color: var(--gray-200);
    margin-bottom: 29px;

    &:hover,
    &:focus {
      background-color: transparent;
    }

    .material-icons:hover {
      background-color: none !important;
    }

    .material-icons.icon-menu {
      transform: rotate(90deg);
    }
  }

  .footer {
    position: absolute;
    bottom: 32px;

    .el-icon-arrow-down {
      display: none;
    }

    .material-icons {
      font-size: 32px;
    }
  }
}

.logout-link,
.account-link {
  padding: 20px 40px 20px 0px;
  box-sizing: border-box;
}

.version-submenu {
  .el-submenu__title {
    padding: 0px !important;

    &:hover,
    &:focus {
      background-color: transparent;
    }
  }

  .plain-text {
    padding-left: 0px !important;
    margin: 10px 20px;
    cursor: pointer !important;

    &:hover {
      background-color: none !important;
    }

    > span {
      display: block;
      margin: 10px 0px;
    }
  }
}

@media (max-width: 768px) {
  .vertical-nav {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    visibility: hidden;

    &.open {
      visibility: visible;
    }

    .sidebar {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      background: var(--background-color);
      box-shadow: -10px 0px 10px 10px rgba(0, 0, 0, 0.2), -10px 0px 20px 20px rgba(0, 0, 0, 0.2);
      transform: translateX(-100%);
      opacity: 0;
      transition: width 0.5s cubic-bezier(0.2, 0, 0, 1) 0s;

      &.pos-right {
        left: initial;
        right: 0;
        box-shadow: 10px 0px 10px 10px rgba(0, 0, 0, 0.2), 10px 0px 20px 20px rgba(0, 0, 0, 0.2);
        transform: translateX(100%);
      }

      &.open {
        opacity: 1;
        transform: translateX(0%);
      }
    }

    .sidebar-mask.open {
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 999;
      right: 0;
      bottom: 0;
      opacity: 1;
      visibility: visible;
    }
  }
}

.avatar-container-logout {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: visible;
  cursor: pointer;
  height: 36px;
  width: 36px;
  background-color: #77dab4;
  margin-left: -8px;
}

.avatar-display-logout {
  background-color: #77dab4;
  display: block;
  height: 36px;
  width: 36px;
  background-color: #77dab4;
}

.avatar-text-logout {
  height: 18px;
  width: 21px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.55px;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheVerticalNav.vue